import EventModal from "./eventModal";

// Calcular la posición del evento en porcentaje (0-90 minutos = 0-100%)
// Clampear entre 0% y 100% para evitar que sobresalga
const getEventPosition = (minute) => {
  const position = (minute / 90) * 100;
  return Math.max(0, Math.min(100, position));
};

// Altura aproximada de cada evento (icon + modal)
const EVENT_HEIGHT = 80; // px

// Componente reutilizable para renderizar evento en línea horizontal (vista Minuto a Minuto)
export const EventItem = ({ event, side }) => {
  // Calcular offset vertical si hay eventos cercanos
  const verticalOffset = (event.offset || 0) * EVENT_HEIGHT;
  
  const offsetStyle = {
    left: `${getEventPosition(event.timeMin)}%`,
    ...(event.offset > 0 && side === "home" && { marginBottom: `${verticalOffset}px` }),
    ...(event.offset > 0 && side === "away" && { marginTop: `${verticalOffset}px` }),
  };

  return (
    <div
      key={`${side}-${event.timeMin}-${event.contestantId}`}
      className={`timeline-event-item timeline-event-item--${side}`}
      style={offsetStyle}
    >
      <EventModal event={event} side={side} />
    </div>
  );
};